import React, {useCallback} from "react";
import DepartureForm from "../Departures/DepartureForm";
import {PublicTransitLayerEntityName,} from "../../../../api/entities/replancity_PublicTransitLine";
import {EntityServiceName} from "../../../../api/enums/enums";
import EntitiesLoader from "../../../../components/Entities/EntitiesLoader/EntitiesLoader";
import {useParams} from "react-router-dom";
import {useToastContext} from "../../../../context/toastContext";
import {useTranslation} from "react-i18next";


const getUrlFunc = ({id}: any) => `./${id}/edit`

const TransitRouteDeparturesList = () => {
    const entityName = PublicTransitLayerEntityName.DEPARTURE;
    const serviceName = EntityServiceName.PUBLIC_TRANSIT;
    const {routeId} = useParams();
    const {addToast} = useToastContext();
    const {t} = useTranslation();

    const onDeleteFn = useCallback((entities: any[]) => {
        if (entities.length === 1) {
            addToast(t("transit-lines.last-departure-deletion"), "warning");
        }
    }, []);

    return (
        <EntitiesLoader
            entityName={entityName}
            serviceName={serviceName}
            parentId={routeId}
            form={DepartureForm}
            getUrlFunc={getUrlFunc}
            onDeleteFn={onDeleteFn}
        />
    )
}

export default TransitRouteDeparturesList;